export default __webpack_public_path__ + "static/media/Kategori Produk-READY TO GO-2.85f99896.jpg";